<template>
	<div class="binding-body">
		<div class="tip-box" v-if="copyFlag === 2">
			<el-tooltip class="item" effect="dark" content="例：私密商品1绑定客户A，客户B，私密商品2绑定客户C；选择私密商品B进行同步，同步成功后私密商品B绑定客户A，客户B" placement="top-start">
				<i class="el-icon-warning"></i>
			</el-tooltip>
		</div>
		<div class="info-box" v-if="copyFlag === 2">
			将该私密商品的全部客户与下方选择的私密商品的客户完全保持一致
		</div>
		<div class="search-box">
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="productName"
					placeholder="请输入商品名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>店铺级大类：</span>
                <el-select v-model="bigTypeCategory" class="name-input" size='mini' @change="bcChange">
					<el-option value="" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
					</template>
				</el-select>
			</div>
            <div class="input-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
                <el-select v-model="smallTypeCategory" class="name-input" size='mini'>
					<el-option value="" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
					</template>
				</el-select>
			</div>
			<div class="input-box">
				<span>SPU编号：</span>
				<el-input
					v-model="productCode"
					placeholder="请输入商品编号"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>三方编号：</span>
				<el-input
					v-model="matchCode"
					placeholder="请输入三方编号"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>销售门店：</span>
				<el-select
					size="mini"
					class="name-input"
					v-model="shopIds"
					filterable
					multiple
					collapse-tags
					placeholder="请选择门店名称">
					<template v-for="item in shopNameList">
						<el-option
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</template>
				</el-select>
			</div>
			<div class="input-box">
				<span>启用状态：</span>
				<el-select v-model="disabledflag" class="name-input" placeholder="请选择启用状态" size='small'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="启用"></el-option>
					<el-option :value="1" label="停用"></el-option>
				</el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="mini"
					@click="search">查询</el-button>
				<el-button
					class="search-btn"
					size="mini"
					plain
					@click="clearSearch">清空</el-button>
			</div>
		</div>
		<div class="search-box">
			<div class="input-box">
				<span>方案名称：</span>
				<el-input
					v-model="planName"
					class="name-input"
					placeholder="请输入方案名称"
					size="mini">
				</el-input>
			</div>
			<div class="input-box">
				<span>选择方案：</span>
				<el-select
					v-model="planId"
					@change="planChange"
					clearable
					placeholder="请选择方案"
					class="name-input"
					size="mini">
					<el-option
						v-for="(item) in planOptions"
						:key="item.id"
						:label="item.schemename"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					size="mini"
					class="plan-btn"
					type="primary"
					@click="savePlan('0')">另存为方案</el-button>
				<el-button
					size="mini"
					class="plan-btn"
					type="primary"
					:disabled="!planId"
					@click="savePlan">保存编辑</el-button>
				<el-button
					size="mini"
					class="plan-btn"
					plain
					:disabled="!planId"
					@click="delPlan">删除方案</el-button>
			</div>
		</div>
		<div class="table-container">
			<div class="table-box">
				<div class="select-title">请选择商品</div>
				<el-table
					:stripe='true'
					ref='multipleTable'
					class="grid-content"
					:data="tableData"
					size='mini'
					:height="tableHeight"
					border
					@select="handleSelectionChange"
					@select-all="handleSelectionChange">
					<el-table-column
					fixed='left'
					type="selection"
					align="center"
					width="55">
					</el-table-column>
						<el-table-column
							prop="productname"
							label="商品名称"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="shopname"
							label="销售店铺"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="bigcategory"
							label="店铺级大类"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							v-if="bigcategoryview === 1"
							prop="smallcategory"
							label="店铺级小类"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="productCode"
							label="SPU编号"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="matchCode"
							label="三方编号"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="disabledflag"
							label="启用状态"
							align="center"
							min-width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.disabledflag">停用</span>
								<span v-else>启用</span>
							</template>
						</el-table-column>
					</el-table>
					<div class="page-box">
						<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="page.number"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="page.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
			<div style="margin-left: 20px;" class="table-box">
				<div class="select-title">已选择商品：{{this.ids.length}}</div>
				<el-table
					:stripe='true'
					ref='multipleTable1'
					class="grid-content"
					:data="ids"
					size='mini'
					:height="tableHeight"
					border
					@select="handleSelectionChange1"
					@select-all="handleSelectionChange1">
					<el-table-column
					fixed='left'
					type="selection"
					align="center"
					width="55">
					</el-table-column>
					<el-table-column
						prop="productname"
						label="商品名称"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="shopname"
						label="销售店铺"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="bigcategory"
						label="店铺级大类"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						v-if="bigcategoryview === 1"
						prop="smallcategory"
						label="店铺级小类"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="productCode"
						label="SPU编号"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="matchCode"
						label="三方编号"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						label="启用状态"
						align="center"
						min-width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.disabledflag">停用</span>
							<span v-else>启用</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="binding-foot">
			<el-button class="btn" plain type="primary" size='small' @click="cancelClick">取消</el-button>
			<el-button class="btn" plain type="primary"  size='small' v-if="copyFlag === 1" @click="saveCopyClick">确认添加</el-button>
			<el-button class="btn" plain type="primary"  size='small' v-if="copyFlag === 2" @click="saveSynchroClick">确认添加</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'copyModal',
	props: {
		proId: String,
		syscodeIds: String,
		proName: String,
		chooseArr: Array,
		copyFlag: Number
	},
	data () {
		return {
			bigcategoryview: 0,
			productName: '',
			productCode: '',
			matchCode: '',
			disabledflag: -1,
			shopIds: [],
			bc: [],
			sc: [],
			bigTypeCategory: '',
			smallTypeCategory: '',
			tableData: [],
			shopNameList: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			tableHeight: '100%',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id'
			}),
			planName: '',
			planId: '',
			planOptions: []
		}
	},
	created () {
		this.checkSmallCategory()
		this.tableReload()
		this.getBigCategory()
		this.getShopList()
		this.getSmalCategory()
		this.getPlan()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopNameList = res
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		bcChange () {
			this.smallTypeCategory = ''
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bigTypeCategory
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.ids, this.$refs.multipleTable1)
			})
		},
		handleSelectionChange1 (data) {
			this.tableSelectUtils.selectToggle(this.ids, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
			})
		},
		getPlan () {
			let params = {
				type: 1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findCustomerScheme`,
				data: params
			}).then(res => {
				if (res.result) {
					this.planOptions = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		savePlan (type) {
			if (!this.planName) {
				this.$message.error('请输入方案名称')
				return false
			}
			if (this.ids.length === 0) {
				this.$message.error('请选择商品')
				return false
			}
			const names = this.planOptions.map(item => {
				return item.schemename
			})

			if (names.indexOf(this.planName) !== -1 && type === '0') {
				this.$message.error('方案名称重复')
				return false
			}
			const details = this.ids.map(item => {
				return {
					productId: item.productid,
					shopId: item.shopid
				}
			})
			let params = {
				type: 1,
				customerSchemeName: this.planName,
				customerSchemeDetails: details
			}
			if (this.planId && type !== '0') {
				params.customerSchemeId = this.planId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/savaOrUpdateCustomerScheme`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.getPlan()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		delPlan () {
			let params = {
				customerSchemeId: this.planId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/removeCustomerScheme`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.getPlan()
					this.planName = ''
					this.planId = ''
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		planChange (e) {
			if (e) {
				const detail = this.planOptions.filter(item => {
					return e === item.id
				})[0]
				this.planName = detail.schemename
				this.planId = detail.id
				detail.detail.forEach(item => {
					item.id = item.productId + item.shopId
				})
				this.tableSelectUtils.selectToggle(this.tableData, detail.detail)
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
					this.tableSelectUtils.setTableDefaultSelect(this.ids, this.$refs.multipleTable1)
				})
			} else {
				this.planName = ''
				this.planId = ''
				this.tableSelectUtils.clear()
				this.tableReload()
			}
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveSynchroHandle () {
			let arr = []
			let textArr = []
			this.ids.forEach(item => {
				let row = {
					productid: item.productid,
					shopid: item.shopid
				}
				let text = `【“私密商品：${item.productname}”，销售门店${item.shopname}】`
				textArr.push(text)
				arr.push(row)
			})
			this.saveSynchro(arr, textArr)
		},
		saveSynchroClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择商品')
				return false
			}
			this.$confirm('将该私密商品的全部客户与下方选择的私密商品的客户完全保持一致，确定继续操作？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: '',
				closeOnClickModal: false
			}).then(() => {
				this.saveSynchroHandle()
			}).catch(() => {
			})
		},
		saveSynchro (arr, textArr) {
			let params = {
				productId: this.proId,
				operatedProductShopIds: arr
			}
			let changeData = {
				info: `将“私密商品：${this.proName}”绑定的”全部客户”同步到` + textArr.join(',')
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/synCustomerProductToOtherProduct`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.$emit('cancel', false)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveCopyClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择商品')
				return false
			}
			let arr = []
			let textArr = []
			this.ids.forEach(item => {
				let row = {
					productid: item.productid,
					shopid: item.shopid
				}
				let text = `【“私密商品：${item.productname}”，销售门店${item.shopname}】`
				textArr.push(text)
				arr.push(row)
			})
			this.saveCopy(arr, textArr)
		},
		saveCopy (arr, textArr) {
			let params = {
				copiedProductId: this.proId,
				syscodeIds: this.syscodeIds,
				productShopIds: arr
			}
			let list = this.chooseArr
			let proArr = []
			list.forEach(item => {
				let text = `【”私密商品：${item.pname}”，“销售门店：${item.shopname}”绑定的”客户：${item.customerName}”】`
				proArr.push(text)
			})
			let changeData = {
				info: `将` + proArr.join(',') + '复制到' + textArr.join(',')
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/copyproducts`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.$emit('cancel', false)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clearSearch () {
			this.productCode = ''
			this.productName = ''
			this.bigTypeCategory = ''
			this.smallTypeCategory = ''
			this.matchCode = ''
			this.disabledflag = -1
			this.shopIds = []
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		search () {
			this.tableSelectUtils.clear()
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		tableReload () {
			let params = {
				copiedProductId: this.proId,
				productName: this.productName,
				productCode: this.productCode,
				disabledflag: this.disabledflag,
				matchCode: this.matchCode,
				shopIds: this.shopIds,
				bigTypeCategory: this.bigTypeCategory,
				smallTypeCategory: this.smallTypeCategory,
				page: this.page.number,
				size: this.page.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getProductOfCopy`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				if (this.tableData !== null) {
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
					})
				}
				this.total = +res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
	position: relative;
    display: flex;
    width :100%;
	flex-direction: column;
    height :600px;
	.tip-box{
		display: inline-block;
		position: absolute;
		top: -44px;
		left: 180px;
		font-size: 18px
	}
	.info-box{
		margin-bottom: 10px;
		color: red;
		text-align: left
	}
	.search-box{
		width:100%;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			margin-left: 10px
			.plan-btn {
				width:100px
			}
		}
		.input-box{
			width :250px;
			margin-bottom:10px
			&>span {
				display: inline-block;
				width: 100px;
			}
			.name-input {
				width: 140px;
				margin-right: 10px;
			}
			.select-box{
				width:100px;
				margin-right:10px;
			}
		}
	}
	.table-container{
		display: flex;
		box-sizing: border-box
		flex-direction: row
		height:calc(100% - 110px);
	}
	.page-box{
		margin-top: 5px
	}
	.grid-content{
		height: calc(100% - 70px) !important
	}
	.table-box{
		height: 100%;
		width: calc(50% - 10px)
	}
	.select-title{
		line-height: 30px;
		text-align: left
	}
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left:30px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
.cell{
	padding: 0 !important
}
</style>
